import {Component, Input, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {IPagedDataService} from "../PagedDataService";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'filter-pagination',
    templateUrl: './filter-pagination.component.html',
    styleUrls: ['./filter-pagination.component.css'],
    imports: [
        MatPaginator,
        CommonModule,
        FormsModule
    ],
    standalone:true,
    providers: []
})
export class FilterPaginationComponent {
    constructor() {
    }

    @Input() public pagedDataService: IPagedDataService | undefined;
    @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
    @Input() public useAdditionalButtons: boolean = false;

    public clearFilter() {
        if (this.pagedDataService) {
            this.pagedDataService.filterText = '';
        }
    }

    onKeyDown(event: KeyboardEvent) {
        if (event.ctrlKey && event.shiftKey && event.key === 'Enter') {
            this.toggleFilterDebugging();
        }
    }

    private toggleFilterDebugging() {
        // Press Ctrl+Shift+Enter to toggle filter debugging.
        this.pagedDataService!.debugFilter = true;
        if (this.pagedDataService!.debugFilter) {
            console.log("FILTER DEBUGGING ENABLED")
        } else {
            console.log("(filter debugging disabled)")
        }
    }
}
